import React from 'react';
import Details from '../../components/Details';
import useGetModel from '../../hooks/use-get-model';

export default () => {

    useGetModel();
    
    return (
        <Details />
    );
}